@if(user){
    <button mat-icon-button [matMenuTriggerFor]="userActions" aria-label="Open user menu">
        <span class="relative">
            @if (showAvatar && user.avatar) {
                <img class="rounded-full w-7 h-7" [src]="user.avatar">
            }
            @if (!showAvatar || !user.avatar) {
                <mat-icon class="icon-size-7" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            }
            <span
                class="absolute bottom-0 right-0 w-2 h-2 rounded-full"
                [ngClass]="{
                    'mb-px mr-px': !showAvatar || !user.avatar
                }"
            ></span>
        </span>
    </button>
    <mat-menu [xPosition]="'before'" #userActions="matMenu">
        <div class="flex flex-col px-4 py-3 leading-none cursor-default">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{ user.email }}</span>
        </div>
        <mat-divider class="my-2"></mat-divider>
        @if(permissionsService.checkPermissions({ minimumRole: role.Administrator})) {
            <a mat-menu-item [routerLink]="['/maintenance']">
                <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
                <span>Maintenance</span>
            </a>
        }
        <button mat-menu-item (click)="userProfile()">
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"/>
            <span>User profile</span>
        </button>
        @if (!permissionsService.isTutor()) {
            <a mat-menu-item href="/">
                <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
                <span>Back to old version</span>
            </a>
        }
        <mat-divider class="my-2"></mat-divider>
        <button mat-menu-item (click)="signOut()">
            <mat-icon
                [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
            ></mat-icon>
            <span>Sign out</span>
        </button>
        <mat-divider class="my-2"></mat-divider>
        <div class="box-border flex w-full max-w-full items-center justify-end gap-1 overflow-x-hidden px-4 pb-2 pt-0 text-sm text-gray-500">
            <span class="cursor-default select-text">Version {{ buildInfo.buildNumber }}</span>
            <tms-button
                type="button"
                [icon]="'heroicons_outline:clipboard-document'"
                [tooltip]="'Copy version'"
                [class]="'shrink-0 !h-6 !w-6 !min-w-0 !gap-0 !p-0 !mx-0 border-0 bg-transparent text-gray-500 shadow-none hover:bg-gray-100 hover:!scale-100 active:!scale-100 [&_mat-icon]:icon-size-4'"
                (click)="copyBuildVersion($event)"
            ></tms-button>
        </div>
    </mat-menu>
}
